(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aart-shared-artwork"] && !Shopify.designMode) return;
  try {
    function initArtworkReadingPreview(scope){
  scope.querySelectorAll('[data-reading-preview] .aart-shared-note').forEach(section=>{
    if(section.dataset.readingReady)return;
    const prose=section.querySelector('.aart-preview-prose');
    const button=section.querySelector('.aart-preview-toggle');
    if(!prose||!button)return;
    section.dataset.readingReady='true';
    const excerpt=document.createElement('p');
    excerpt.className='aart-preview-excerpt';
    excerpt.hidden=true;
    prose.before(excerpt);
    const opening=(prose.querySelector('p')||prose).textContent.trim();
    const sentences=typeof Intl.Segmenter==='function'?[...new Intl.Segmenter(document.documentElement.lang||'en',{granularity:'sentence'}).segment(opening)].map(part=>part.segment):opening.match(/[^.!?。！？]+[.!?。！？]+|[^.!?。！？]+$/g)||[opening];
    excerpt.textContent=sentences.slice(0,2).join('').trim();
    let expanded=false,lastWidth=0;
    const measure=()=>{
      prose.hidden=false;
      excerpt.hidden=true;
      const lineHeight=parseFloat(getComputedStyle(prose).lineHeight);
      if(!Number.isFinite(lineHeight))return;
      const long=prose.scrollHeight>lineHeight*6&&excerpt.textContent.length<prose.textContent.trim().length;
      button.hidden=!long;
      prose.hidden=long&&!expanded;
      excerpt.hidden=!long||expanded;
    };
    button.addEventListener('click',()=>{
      expanded=!expanded;
      button.textContent=expanded?button.dataset.less:button.dataset.more;
      button.setAttribute('aria-expanded',String(expanded));
      measure();
    });
    new ResizeObserver(entries=>{const width=entries[0].contentRect.width;if(Math.abs(width-lastWidth)>.5){lastWidth=width;measure();}}).observe(section);
    measure();
    if(document.fonts)document.fonts.ready.then(measure);
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initArtworkReadingPreview(document));}else{initArtworkReadingPreview(document);}
document.addEventListener('shopify:section:load',event=>initArtworkReadingPreview(event.target));

function initArtworkGallery(scope){
 scope.querySelectorAll('[data-gallery]').forEach(gallery=>{
  if(gallery.dataset.ready)return;
  gallery.dataset.ready='true';
  const track=gallery.querySelector('.aart-gallery-track'),slides=[...track.querySelectorAll('a')],controls=gallery.querySelector('.aart-gallery-controls'),prev=gallery.querySelector('[data-prev]'),next=gallery.querySelector('[data-next]'),count=gallery.querySelector('[data-count]'),dialog=gallery.querySelector('dialog');
  let index=0,opener=null;
  const update=()=>{index=Math.round(track.scrollLeft/track.clientWidth);if(count){count.textContent=`${index+1} / ${slides.length}`;prev.disabled=index===0;next.disabled=index===slides.length-1;}};
  const go=step=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,index+step))*track.clientWidth,behavior:'auto'});
  if(controls){controls.hidden=false;prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));}
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1);}});
  new ResizeObserver(()=>{track.scrollTo({left:index*track.clientWidth,behavior:'auto'});update();}).observe(track);
  slides.forEach(slide=>slide.addEventListener('click',event=>{if(!dialog.showModal)return;event.preventDefault();opener=slide;const image=slide.querySelector('img'),zoom=dialog.querySelector('img');zoom.src=image.src;zoom.alt=image.alt;dialog.showModal();}));
  gallery.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{if(opener)opener.focus({preventScroll:true});});
  update();
 });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initArtworkGallery(document));}else{initArtworkGallery(document);}
document.addEventListener('shopify:section:load',event=>initArtworkGallery(event.target));
  } catch(e) { console.error(e); }
})();

})();
